// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_3v-0";
export var eligibilityCardNotEligible = "_3v-1";